var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9169",
    "data-name": "Group 9169",
    transform: "translate(-2237.486 -3441.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9167",
    "data-name": "Group 9167",
    transform: "translate(2237.486 3441.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9135",
    "data-name": "Group 9135",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1647",
    "data-name": "Ellipse 1647",
    cx: 53,
    cy: 53,
    r: 53,
    fill: "#ff6565"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9168",
    "data-name": "Group 9168",
    transform: "translate(2263.073 3466.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19708",
    "data-name": "Path 19708",
    d: "M257.888,279.531a1.15,1.15,0,0,1-.812-.334l-9.548-9.548a1.15,1.15,0,0,1-.046-1.578l11.063-12.393a1.3,1.3,0,0,1,.264-.277c7.866-9.021,19.97-14.681,31.031-14.431a1.149,1.149,0,0,1,1.122,1.122c.16,7.485-2.367,15.531-7.124,22.653a1.149,1.149,0,0,1-1.91-1.276,38.794,38.794,0,0,0,6.742-20.207c-9.959.174-21.163,5.6-28.216,13.746a1.161,1.161,0,0,1-.162.154l-10.374,11.628,8.78,8.78a1.148,1.148,0,0,1-.812,1.959Z",
    transform: "translate(-235.877 -240.963)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19709",
    "data-name": "Path 19709",
    d: "M254.734,260.726a1.006,1.006,0,0,1-.165-.011l-10.988-1.574a1.149,1.149,0,0,1-.648-1.948,28.746,28.746,0,0,1,20.5-8.532,1.148,1.148,0,0,1,0,2.3,26.39,26.39,0,0,0-17.14,6.255l8.6,1.232a1.147,1.147,0,0,1-.162,2.283Z",
    transform: "translate(-239.72 -234.524)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19710",
    "data-name": "Path 19710",
    d: "M265.057,257.876a5.738,5.738,0,0,1-4.059-9.8,5.874,5.874,0,0,1,8.114,0,5.738,5.738,0,0,1-4.055,9.8Zm0-9.179a3.443,3.443,0,0,0-2.435,5.879,3.524,3.524,0,0,0,4.869,0,3.448,3.448,0,0,0,0-4.87,3.413,3.413,0,0,0-2.433-1.008Zm3.245,6.688h0Z",
    transform: "translate(-225.732 -236.369)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19711",
    "data-name": "Path 19711",
    d: "M242.177,279.324a1.144,1.144,0,0,1-1.1-1.476c.375-1.254,3.746-12.35,6.2-14.806a7.094,7.094,0,1,1,10.033,10.033c-2.455,2.455-13.549,5.827-14.808,6.2A1.234,1.234,0,0,1,242.177,279.324ZM252.3,263.26a4.8,4.8,0,0,0-3.4,1.4c-1.324,1.328-3.528,7.25-4.98,11.768,4.518-1.454,10.444-3.658,11.768-4.982a4.793,4.793,0,0,0-3.392-8.187Z",
    transform: "translate(-241.031 -224.229)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19712",
    "data-name": "Path 19712",
    d: "M269.7,284.554a14.919,14.919,0,1,1,14.918-14.919A14.935,14.935,0,0,1,269.7,284.554Zm0-27.543a12.624,12.624,0,1,0,12.624,12.624A12.638,12.638,0,0,0,269.7,257.011Z",
    transform: "translate(-229.531 -229.459)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19713",
    "data-name": "Path 19713",
    d: "M264.267,271.192a1.155,1.155,0,0,1-.814-.336l-4.589-4.589a1.147,1.147,0,1,1,1.622-1.623l3.724,3.723,7.225-8.259a1.148,1.148,0,0,1,1.726,1.513l-8.034,9.18a1.137,1.137,0,0,1-.823.391Z",
    transform: "translate(-226.395 -225.278)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailability);
export default __webpack_public_path__ + "static/media/Availability.3a0264c9f45d3ec57727a0ca4d164580.svg";
export { ForwardRef as ReactComponent };